import React from "react";

export default function FilingAssistantMenu({
    isVisible,
    setVisible,
    onAccurateFileName,
    onAccurateFolderName,
    onClickFileReportHistory,
    onClickViewUnallocatedFiles,
    checkDuplicatedFiles,
    onClickDeduperReportHistory,
}) {
    return (
        <div className="pr df filing-assistant-pos jce aife">
            <div className="menuHover pr">
                <button
                    onMouseEnter={() => setVisible(true)}
                    className="w200px btn-filing-assistant shadow bg3 bg4-hover c1 td250 br5px px1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic fs0-75rem"
                >
                    <span className="tooltip-area" style={{ top: '-8px', right: '-8px' }}>
                        <i className="icon">
                            <img className="h3rem" src={require(`../../../../../../../images/info-icon.svg`)} alt="" />
                            <div className="overlay-box">
                                <p>You can always manually upload files into our repository using our checklist questions below.</p>
                                <p>However, our Filing Assistant enables you to point to the Data Room/folders/files you would like us to quickly ingest into your Diligentsia Data Repository and our Filing Assistant will automatically allocate them to the various sections within our repository index structure in seconds</p>
                                <p>Prior to actual allocation, our Filing Assistant Manager allows you to review our proposed allocation of files to sections and if necessary reallocate before you "go firm".</p>
                                <p>You can also use our deduper feature to remove unwanted duplicate files.</p>
                                <p>We provide complete audit logs and reports within the Data Repository itself.</p>
                            </div>
                        </i>
                    </span>
                    Filing Assistant
                </button>
                {isVisible && (
                    <div className="miw100 menu op0 bsbb bw0px bbw5px bss bo3 zi1 bg1 shadow td250 pen p0-5rem pa t100 r0 df fdc">
                        <label onClick={onAccurateFileName} className="bsbb wsn w100 td250 c4-hover p0-5rem ass cp">
                            <span>Import Files</span>
                        </label>
                        <label onClick={onAccurateFolderName} className="bsbb w100 wsn td250 c4-hover p0-5rem ass cp">
                            <span>Import Folders</span>
                        </label>
                        <p onClick={onClickFileReportHistory} className="bsbb w100 td250 c4-hover p0-5rem ass cp wsn">
                            Filing Assistant Manager
                        </p>
                        <p onClick={onClickViewUnallocatedFiles} className="bsbb w100 td250 c4-hover p0-5rem ass cp wsn">
                            View Unallocated Files
                        </p>
                        <p onClick={() => checkDuplicatedFiles()} className="bsbb w100 td250 c4-hover p0-5rem ass cp wsn">
                            Deduper
                        </p>
                        <p onClick={onClickDeduperReportHistory} className="bsbb w100 td250 c4-hover p0-5rem ass cp wsn">
                            Deduper Reports
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}
